import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { twitterAutomationKeys } from '../twitterAutomation.keys';
import { deleteAutomation } from '../twitterAutomation.service';
export const useDeleteAutomation = (subdomain = getSubdomain()) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (automationId) => deleteAutomation(subdomain, automationId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: twitterAutomationKeys.list(subdomain) });
        },
    });
};
